var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tabbar',{attrs:{"tabbar":_vm.navData}})
}
var staticRenderFns = []

export { render, staticRenderFns }